/** * @description: 重构备机列表 * @param {*} * @return {*} */
<template>
  <!-- ContractSearch   userInfo
  ServerRepairDetailSearchForComplate
  -->
  <div class="user-management-container">
    <tabel-panel ref="tabel" :rowTemplate="rowTemplate" api="PreMachineListSearch"
      :condition="conditionData" editType="pop" :autoSearch="true" :showCancelButton="false"
      @popConfirmButtonClick="popConfirmButtonClick" :clickRowSelected="false"
      @customerRowDblClick="customerRowDblClick" :popToCustomer="true"
      @getReqData="getReqData">
      <template v-slot:tabelTitleLeft>
        <div>服务列表</div>
      </template>
      <template v-slot:tabelTitleRight>
        <!-- <add-button @buttonClick="addList"> 添加 </add-button> -->
        <add-button @buttonClick="addProductBtn">
          添加
        </add-button>
      </template>

      <template v-slot:condition style="height: 200px;">
        <!-- <text-field v-model:value="condition.BrandId" labelText="品牌名称:" :clearable="true" type="select"
          class="condition-container-input" :selectChildData="options.compid" @change="handleCompid" />
        <text-field v-model:value="condition.ProductId" labelText="产品类别:" :clearable="true" type="select"
          class="condition-container-input" :selectChildData="options.ProductId" @change="handleProductId" />
        <text-field v-model:value="condition.ModelNoId" labelText="产品型号:" :clearable="true" type="select"
          class="condition-container-input" :selectChildData="options.ModelNoId" />

        <text-field v-model:value="condition.sn" labelText="SN:" class="condition-container-input">
        </text-field> -->

        <text-field v-model:value="conditionData.BrandId" labelText="品牌名称:" :clearable="true" type="select"
          :selectRemoteSearchData="selectOuguBrand" class="condition-container-input"></text-field>

        <text-field v-model:value="conditionData.ProductId" labelText="产品类别:" ref="selectChild" :clearable="true"
          :type="selectChildData == null ? 'select' : 'selectChild'" :selectChildData="selectChildData"
          :selectRemoteSearchData="selectOuguNameProductTwo" class="condition-container-input">
        </text-field>

        <text-field v-model:value="conditionData.ModelId" labelText="产品型号:" ref="selectChildMoid" :clearable="true"
          :type="selectChildMoid == null ? 'select' : 'selectChild'" :selectChildData="selectChildMoid"
          :selectRemoteSearchData="selectOuguNameModelSelect" class="condition-container-input">
        </text-field>

        <text-field 
          v-model:value="conditionData.sn" 
          labelText="SN:" 
          class="condition-container-input"
          clearable
        >
        </text-field>
      </template>

      <template v-slot:goBackBtn="$opData">
        <div class="style-aaa" @click="delSingleUser($opData.data.row)">删除</div>
        <!-- <div class="opration"> -->
        <!-- <del-Border
          class="item"
          :useConfirm="true"
          comfirmMessage="确定删除吗？"
          comfirmOkText="确定"
          comfirmCancelText="取消"
          @buttonClick="delSingleUser($opData.data.row)"
        >
        </del-Border> -->
        <!-- </div> -->
      </template>
    </tabel-panel>

     <!-- 
      @confirmClick="listDataSave" 
      id="loadBOX"
      :boxMaxHeight="true"
      添加列表
      :boxMaxWidth="true"
    -->
     <pop-dialog   
        v-if="loadShow" 
        ref="getMenuList" 
        :meta="popDialogList"
        :showButtons="false"
        maxWidth="86%"
        @dialogClose="loadShow = false">
          <template v-slot>
            <!-- <div style="height: 500px;"> -->
              <div id="dialogBox"
              style="height: 530px;"
              >
              <tabel-panel  
                :popToCustomer="true"
                :clickRowSelected="false"
                :showCancelButton="false"
                :autoSearch="true" 
                api="listData"
                :apiData="popListData"
                ref="tabel2" :rowTemplate="popTemplate"
                :condition="popDataSubmit" 
                @searchBTN="searchBTN"
                >
                <template v-slot:tabelTitleLeft>
                  <!-- <div style="width:90%;"> -->
                    <text-field 
                      v-model:value="dialogFormDataCondition.BrandName" 
                      labelText="品牌名称:" :readOnly="true" 
                      :clearable="true"
                      class="condition-container-input">
                    </text-field>
                    <text-field 
                    v-model:value="dialogFormDataCondition.ProCateName" 
                      labelText="产品类型:" :readOnly="true"
                      :clearable="true" 
                      class="condition-container-input">
                    </text-field>
                    <text-field 
                      v-model:value="dialogFormDataCondition.ModelNoName" 
                      labelText="产品型号:" 
                      :readOnly="true"
                      :clearable="true" 
                      class="condition-container-input">
                    </text-field>
                    <text-field 
                      v-model:value="dialogFormDataCondition.SerialNoName" 
                      labelText="SN:" 
                      :readOnly="true" 
                      :clearable="true"
                      class="condition-container-input">
                    </text-field>
                    <text-field 
                      v-model:value="dialogFormDataCondition.PreMachDesc" 
                      labelText="备注:" 
                      :clearable="true"
                      class="condition-container-input">
                    </text-field>
                    <!-- 
                        v-model:value="popDataSubmit.cmp" labelText="客户:" 
                        :clearable="true" type="select"
                        :selectRemoteSearchData="selectOuguName" 
                        class="condition-container-input">
                        :fieldData="[{label:'是',vlaue: 1},{label:'否',vlaue: 0}]"
                        :selectRemoteSearchData="selectOuguNameGuiHuan"
                     -->
                    <text-field v-model:value="dialogFormDataCondition.IsRuturn" 
                      labelText="是否归还:" 
                      :clearable="true" 
                      type="select"
                      :selectRemoteSearchData="selectOuguNameGuiHuan"
                      class="condition-container-input">
                    </text-field>
                  <!-- </div> -->
                </template>
                <template v-slot:tabelTitleRight>
                  <add-button @buttonClick="listSubmitBtn"
                    style="margin-left:10px; margin-right: 0.125rem;"
                  >
                    保存
                  </add-button>
                </template>

                <template v-slot:condition >
                  <text-field
                    @change="hendCompId"
                    v-model:value="popDataSubmit.cmp" labelText="客户:" :clearable="true" type="select"
                    :selectRemoteSearchData="selectOuguName" class="condition-container-input">
                  </text-field>
                  <text-field v-model:value="popDataSubmit.link" labelText="联系人:" class="condition-container-input">
                  </text-field>
                  <!-- <text-field 
                    @change="LinkManBtn"
                    v-model:value="popDataSubmit.link" class="condition-container-input"
                    labelText="联系人:" ref="selectChild" 
                    :clearable="true"
                    :type="selectChildData == null ? 'select' : 'selectChild'" 
                    :selectChildData="selectChildData"
                    :selectRemoteSearchData="selectOuguNameProduct">
                  </text-field> -->
                  <text-field v-model:value="popDataSubmit.trs" type="date" labelText="寄送起始日期:" clearable
                    class="condition-container-input">
                  </text-field>
                  <text-field v-model:value="popDataSubmit.tre" type="date" labelText="寄送结束日期:" clearable
                    class="condition-container-input">
                  </text-field>
                  <text-field v-model:value="popDataSubmit.trn" labelText="寄送单号:" class="condition-container-input">
                  </text-field>
                  <text-field v-model:value="popDataSubmit.res" type="date" labelText="归还起始日期:" clearable
                    class="condition-container-input">
                  </text-field>
                  <text-field v-model:value="popDataSubmit.ree" type="date" labelText="归还结束日期:" clearable
                    class="condition-container-input">
                  </text-field>
                  <text-field v-model:value="popDataSubmit.ren" labelText="归还单号:" class="condition-container-input">
                  </text-field>
                </template>

                <template v-slot:goBackBtn="$opData">
                  <div class="style-aaa" @click="delSingleUser($opData.data.row)">删除</div>
                  <!-- <div class="opration"> -->
                  <!-- <del-Border
                    class="item"
                    :useConfirm="true"
                    comfirmMessage="确定删除吗？"
                    comfirmOkText="确定"
                    comfirmCancelText="取消"
                    @buttonClick="delSingleUser($opData.data.row)"
                  >
                  </del-Border> -->
                  <!-- </div> -->
                </template>
              </tabel-panel>
            </div>
          </template>
      </pop-dialog>
      <!-- 
        添加产品
        :showButtons="false"
       -->
      <pop-dialog   
        id="loadBOX"
        v-if="addProductShow" 
        ref="getMenuList2" 
        :meta="popDialogList"
        textButtons="保存"
        :showCancelButton="false"
        :boxMaxWidth="true"
        @dialogClose="addProductShow = false"
        @confirmClick="saveBTN">
          <template v-slot>
            <div class="saveBox" >
                    <el-row :gutter="20">
                        <el-col :span="12">
                            <div class="grid-content bg-purple">
                                <span class="colorRed">*</span>
                                品牌名称:
                                <el-select v-model="popSaveData.BrandId" clearable placeholder="请选择"
                                    @change="addProductSelect" required size="small">
                                    <el-option v-for="item in BrandData" :key="item.id" :label="item.Name"
                                        :value="item.id">
                                    </el-option>
                                </el-select>
                            </div>
                        </el-col>
                        <el-col :span="12">
                            <div class="grid-content bg-purple">
                                <span class="colorRed">*</span>
                                产品类别:
                                <el-select v-model="popSaveData.ProductId" clearable size="small" placeholder="请选择"
                                    @change="addModelSelect">
                                    <el-option v-for="item in ProductData" :key="item.id" :label="item.Name"
                                        :value="item.id">
                                    </el-option>
                                </el-select>
                            </div>
                        </el-col>
                    </el-row>
                    <el-row :gutter="20">
                        <el-col :span="12">
                            <div class="grid-content bg-purple">
                                <span class="colorRed">*</span>
                                产品型号:
                                <el-select v-model="popSaveData.ModelNo_Id" clearable size="small" placeholder="请选择">
                                    <el-option v-for="item in modelData" :key="item.id" :label="item.Name"
                                        :value="item.id">
                                    </el-option>
                                </el-select>
                            </div>
                        </el-col>
                        <el-col :span="12">
                            <div class="grid-content bg-purple">
                                <span class="colorRed">*</span>
                                SN号:
                                <el-input size="small" v-model="popSaveData.sn" placeholder="请输入SN号" required
                                    @change="SNSearch" class="inputSN"></el-input>
                            </div>
                        </el-col>
                    </el-row>
                    <div>
                        <span>附件:</span>
                          <el-checkbox-group v-model="popSaveData.Attach">
                              <el-checkbox v-for="attach in AttachData" :label="attach.id" :key="attach.id"
                                  :value="attach.Name">
                                  {{ attach.Name }}
                              </el-checkbox>
                          </el-checkbox-group>
                    </div>
                    <el-row :gutter="20">
                        <el-col :span="12">
                            <div class="grid-content bg-purple">
                                <span class="colorRed">*</span>
                                返回地:
                                <el-select v-model="popSaveData.Company_Id" placeholder="请选择" size="small">
                                  <el-option v-for="item in sendBackForm.options" 
                                  :key="item.value" 
                                  :label="item.label" 
                                  :value="item.value"
                                  />
                                </el-select>
                            </div>
                        </el-col>
                        <el-col :span="12">
                        </el-col>
                    </el-row>
                    <el-row :gutter="20">
                        <el-col :span="24">
                            <div class="grid-content bg-purple">
                                <span class="colorRed">*</span>
                                备注:
                                <el-input size="small" 
                                  type="textarea" 
                                  :autosize="{ minRows: 4, maxRows: 4 }"
                                  placeholder="请输入内容" 
                                  v-model="popSaveData.PreMachDesc">
                                </el-input>
                            </div>
                        </el-col>
                    </el-row>
                </div>
          </template>
      </pop-dialog>

    <!-- 添加 -->
    <el-dialog v-model="addDialog" width="86%" center>
      <div class="dialogBox">
        <el-form :model="ruleForm" ref="ruleForm" label-width="100px" label-position="right" class="demo-ruleForm">
          <el-row>
            <el-col :span="2"></el-col>
            <el-col :span="5">
              <div class="grid-content bg-purple">
                <el-form-item label="客户:" prop="CusCopmany_Id">
                  <el-select v-model="ruleForm.CusCopmany_Id" placeholder="请选择" size="small" @change="CompanyContract">
                    <el-option v-for="(item, index) in CompanyIdData" :label="item.CompName" :value="item.Company_Id"
                      :key="index">
                      {{ item.CompName }}
                    </el-option>
                  </el-select>
                </el-form-item>
              </div>
            </el-col>

            <el-col :span="5">
              <div class="grid-content bg-purple-light">
                <el-form-item label="公司联系人:" prop="DicInfoId">
                  <el-select v-model="ruleForm.DicInfoId" placeholder="请选择活动区域" size="small"
                    @change="CompanyContracsData" value-key="Id">
                    <el-option v-for="(item, index) in CompanyContacts" :key="index" :label="item.LinkMan"
                      :value="item">
                    </el-option>
                  </el-select>
                </el-form-item>
              </div>
            </el-col>
            <el-col :span="5">
              <div class="grid-content bg-purple">
                <el-form-item label="联系人:" prop="LinkMan">
                  <el-input v-model="ruleForm.LinkMan" size="small"></el-input>
                </el-form-item>
              </div>
            </el-col>
            <!-- 日期 -->
            <el-col :span="5">
              <el-form-item label="联系电话:" prop="TelNo">
                <el-input v-model="ruleForm.TelNo" size="small"></el-input>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row>
            <el-col :span="2"></el-col>
            <el-col :span="5">
              <div class="grid-content bg-purple">
                <!-- CompanyIdData -->
                <el-form-item label="手机:" prop="Phone">
                  <el-input v-model="ruleForm.Phone" size="small"></el-input>
                </el-form-item>
              </div>
            </el-col>

            <el-col :span="5">
              <div class="grid-content bg-purple-light">
                <el-form-item label="邮箱:" prop="Email">
                  <el-input v-model="ruleForm.Email" size="small"></el-input>
                </el-form-item>
              </div>
            </el-col>

            <el-col :span="5">
              <div class="grid-content bg-purple">
                <el-form-item label="服务类型:" prop="ServerType_Id">
                  <el-select v-model="ruleForm.ServerType_Id" placeholder="请选择" size="small">
                    <el-option v-for="(item, index) in ServerType" :key="index" :label="item.Name" :value="item.Id">
                    </el-option>
                  </el-select>
                </el-form-item>
              </div>
            </el-col>
            <!-- 日期 -->
            <el-col :span="5">
              <el-form-item label="预约日期:" prop="OrderDate">
                <el-date-picker type="date" placeholder="选择日期" v-model="ruleForm.OrderDate" size="small"
                  style="width: 100%;" @change="getBirthTime($event, 'OrderDate')">
                </el-date-picker>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row>
            <el-col :span="2"></el-col>
            <el-col :span="5">
              <div class="grid-content bg-purple-light">
                <el-form-item label="服务起始日期:" prop="AddDate">
                  <el-date-picker v-model="ruleForm.AddDate" type="datetime" size="small" placeholder="选择日期时间"
                    format="YYYY-MM-DD HH:mm:ss" @change="getBirthTime($event, 'AddDate')">
                  </el-date-picker>
                </el-form-item>
              </div>
            </el-col>

            <el-col :span="5">
              <div class="grid-content bg-purple">
                <el-form-item label="工程师:" prop="PlantUserId">
                  <el-select v-model="ruleForm.PlantUserId" value-key="Id" placeholder="请选择" size="small"
                    @change="getContracsArr">
                    <el-option v-for="(item, index) in engineerData" :label="item.Name" :value="item" :key="index">
                    </el-option>
                  </el-select>
                </el-form-item>
              </div>
            </el-col>

            <el-col :span="8">
              <div class="grid-content bg-purple">
                <el-form-item label="工程师标注:" prop="PlantUserName">
                  <el-input v-model="ruleForm.PlantUserName" size="small" disabled></el-input>
                </el-form-item>
              </div>
            </el-col>
          </el-row>

          <el-row>
            <el-col :span="2"></el-col>
            <el-col :span="15">
              <el-form-item label="服务描述:" prop="ServerDesc">
                <el-input type="textarea" v-model="ruleForm.ServerDesc"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="2"></el-col>
            <el-col :span="15">
              <el-form-item label="备注:" prop="Appendix">
                <el-input type="textarea" v-model="ruleForm.Appendix"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="3">
              <add-button type="primary" @click="submitForm('ruleForm')">保存</add-button>
            </el-col>
            <el-col :span="3">
              <control-button @click="resetForm('ruleForm')">重置</control-button>
            </el-col>
          </el-row>
        </el-form>
      </div>
    </el-dialog>

    <!-- 列表编辑 -->
    <el-dialog v-model="editListDialog" 
      width="80%" 
      top="10vh"
      title="备机借用详细信息"
    >
      <div class="dialogBox">
        <div style="display: flex;justify-content: space-around; margin-bottonn:16px">
          <text-field v-model:value="editForm.CompName" labelText="客户:" :readOnly="true" :clearable="true"
              class="condition-container-input"></text-field>
            <text-field v-model:value="editForm.LinkMan" labelText="联系人:" :readOnly="true"
              class="condition-container-input"></text-field>
            <text-field v-model:value="editForm.TranDate" labelText="寄送日期:" :readOnly="true"
              class="condition-container-input"></text-field>
            <text-field v-model:value="editForm.TransferNo" labelText="寄送单号:" :readOnly="true"
              class="condition-container-input"></text-field>
        </div>
        <el-form :model="editForm" :rules="rules" ref="editForm" label-width="100px" class="demo-ruleForm">
          <el-row>
            <el-col :span="24">
              <!-- popListData -->
              <tabel-panel ref="tabelSNlist" 
                style="height: 230px;" 
                :rowTemplate="tableCustomer" 
                :showTitle="false"
                editType="pop" 
                :showCondition="false"
                :autoSearch="true" 
                :showCancelButton="false" 
                :clickRowSelected="false" 
                :popToCustomer="true"
                api="listData"
                :apiData="listDetails"
                > 
                <template v-slot:IsReturn="$opData">
                  <div v-if="$opData.data.row.IsReturn != '是'" class="style-aaa" @click="finishBtn($opData.data.row, editForm.Id)">寄回</div>
                </template>
              </tabel-panel>
            </el-col>
          </el-row>
        </el-form>
      </div>
    </el-dialog>
    

    
    <!-- 图片 -->
    <el-dialog v-model="centerDialogVisible" width="30%" :show-close="false" center>
      <div>
        <img style="width:100%;" :src="openImg" />
      </div>
    </el-dialog>
  </div>
</template>

<script>
import axios from "axios";

import { ElMessageBox } from 'element-plus'
import { baseUrl } from "@/http/index.js";
import textField from "@/components/textField.vue";
import delBorder from "@/components/delBorder.vue";
import addButton from "@/components/addButton.vue";
import controlButton from "@/components/controlButton.vue";
import updateButton from "@/components/updateButton.vue";
import tabelPanel from "@/components/tabelPanel.vue";
import popDialog from "@/components/popDialog.vue";
import tableApi from "@/api/tabel.js";
import {
  CompanyInfoes,
  CompanyContractSearch,
  ServerTypeSearch,
  RepairPlantUser,
  ServerPlantAdd,
  ServerRepairDetailDels,
  ShooinCompSearch,
  ServerPlantTasksEditSave,
} from "@/api/index.js";
import { errMsg, successMsg } from "@/notify/index.js";
import { downloadExcel } from "@/util/download.js";

export default {
  name: "shtandby",
  components: {
    textField,
    addButton,
    delBorder,
    tabelPanel,
    popDialog,
    updateButton,
    controlButton,
  },
  data() {
    return {
      finishBox: false,
      TabelSN: false,
      selectDataDicInfoId: [
        {
          label: "维修质保物损",
          value: 3050,
        },
        {
          label: "维修质保延长",
          value: 3051,
        },
        {
          label: "金牌年保服务",
          value: 3052,
        },
        {
          label: "银牌年保服务",
          value: 3053,
        },
      ],
      serveComp: null,
      SNDialog: false,
      addDialog: false,
      editListDialog: false,
      centerDialogVisible: false,
      snListBOX: false,
      loadShow: false,
      addProductShow: false,
      StatementDialog: false,
      rowData: null,
      //反回 
      sendBackForm:{},
      rowTemplate: [
        {
          headerLabel: "品牌",
          dataIndex: "BrandName",
        },
        {
          headerLabel: "产品",
          dataIndex: "ProCateName",
        },
        {
          headerLabel: "型号",
          dataIndex: "ModelNoName",
        },
        {
          headerLabel: "SN",
          dataIndex: "SerialNoName",
        },
        {
          headerLabel: "状态",
          dataIndex: "StateName",
        },
        
        {
          headerLabel: "附件",
          dataIndex: "AttachName",
        },
        {
          headerLabel: "返回地",
          dataIndex: "CompName",
        },
        {
          headerLabel: "备注",
          dataIndex: "PreMachDesc",
        },
        {
          headerLabel: "删除",
          slot: "goBackBtn",
          fixed: "right"
        },
      ],
      // 产品viev
      popDataSubmit: {
        cmp: null,
        link: null,
        trs: null,
        tre: null,
        trn: null,
        res: null,
        ree: null,
        ren: null,
      },
      // 列表条件
      conditionData: {
        userid: null,
        shooinComp: null,
        startTime: null,
        linkMan: null,
        selectOuguName: null,
        end: null,
        desc: null,
      },
      tableCustomerData: null,
      tableCustomer: [
        {
          headerLabel: "品牌",
          dataIndex: "BrandName",
        },
        {
          headerLabel: "产品",
          dataIndex: "ProCateName",
        },
        {
          headerLabel: "型号",
          dataIndex: "ModelNoName",
        },
        {
          headerLabel: "SN",
          dataIndex: "SerialNoName",
        },
        {
          headerLabel: "附件",
          dataIndex: "AttachName",
        },
        {
          headerLabel: "备注",
          dataIndex: "PreMachDesc",
        },
        {
          headerLabel: "归还地",
          dataIndex: "归还地",
        },
        {
          headerLabel: "归还日期",
          dataIndex: "ReturnDate",
        },
        {
          headerLabel: "归还单号",
          dataIndex: "ReTransferNo",
        },
        {
          headerLabel: "归还",
          dataIndex: "IsReturn",
        },
        {
          headerLabel: "寄回",
          slot: "IsReturn",
        },
      ],
      // 服务进度
      CustomerList: {
        Id: null,
      },
      //sn 查询条件
      SNData: {
        compid: 25,
        sn: null,
      },
      //公司查询
      CompanyIdData: [],
      //公司联系人查询
      CompanyContacts: [],
      //公司服务类型
      ServerType: [],
      //工程师查询
      engineerData: [],
      //巡检任务完成
      uploadParam: {
        action:
          baseUrl + "api/ServerPlantTask/ServerPlantTaskEditEditFinishById",
        multiple: false,
        limit: 1,
        autoUpoad: false,
        accept: "",
        fileList: [],
      },
      openImg: "",
      ruleFormFinish: {
        Id: null, // Id	Int	巡检任务Id	是
        AddDate: "", // AddDate	string	服务起始时间	是
        edt: [], // edt	string	完成时间	是
        RoadTime: "", // RoadTime	string	路途时间	是
      },
      rules2: {
        edt9: [
          { required: true, message: "请输入", trigger: "blur" },
          // { min: 3, max: 5, message: '长度在 3 到 5 个字符', trigger: 'blur' }
        ],
        CompanyId: [{ required: true, message: "请输入", trigger: "blur" }],
      },
      editForm: {
        ServerType_Id: null, // ServerType_Id	Int	服务类型Id	是
        LinkMan: "", // LinkMan	string	联系人
        Phone: "", // Phone	string	手机
        TelNo: "", // TelNo	string	电话
        Email: "", // Email	string	邮件
        CusCopmany_Id: null, // CusCopmany_Id	Int	客户Id	是
        OrderDate: "", // OrderDate	string	预约时间
        AddDate: [], // AddDate	string	服务起始时间	是
        ServerDesc: "", // ServerDesc	string	服务描述	是
        Appendix: "", // Appendix	string	备注
        PlantUser: "", // PlantUser	string	工程师
        PlantUserName: [],
        sns: "", // sns	string	SN号
      },
      ruleForm: {
        ServerType_Id: null, // ServerType_Id	Int	服务类型Id	是
        LinkMan: "", // LinkMan	string	联系人
        Phone: "", // Phone	string	手机
        TelNo: "", // TelNo	string	电话
        Email: "", // Email	string	邮件
        CusCopmany_Id: null, // CusCopmany_Id	Int	客户Id	是
        OrderDate: "", // OrderDate	string	预约时间
        AddDate: [], // AddDate	string	服务起始时间	是
        ServerDesc: "", // ServerDesc	string	服务描述	是
        Appendix: "", // Appendix	string	备注
        PlantUser: "", // PlantUser	string	工程师
        PlantUserName: [],
        sns: "", // sns	string	SN号
      },
      rules: {
        cycle: [
          { required: true, message: "请输入", trigger: "blur" },
          // { min: 3, max: 5, message: '长度在 3 到 5 个字符', trigger: 'blur' }
        ],
        CompanyId: [{ required: true, message: "请输入", trigger: "blur" }],
        DicInfoId: [{ required: true, message: "请输入", trigger: "blur" }],
        ContractNo: [{ required: true, message: "请输入", trigger: "blur" }],
        BuyDate: [{ required: true, message: "请输入", trigger: "blur" }],
        EndDate: [{ required: true, message: "请输入", trigger: "blur" }],
        Month: [{ required: true, message: "请输入", trigger: "blur" }],
        sn: [{ required: true, message: "请输入", trigger: "blur" }],
        mid: [{ required: true, message: "请输入", trigger: "blur" }],
      },
      // SN号添加
      snAdd: {
        ModelNo_Id: null, // ModelNo_Id	int	型号Id	是
        ContractId: null, // ContractId	int	合同Id	是
        compid: null, // compid	int	公司Id
        NotExpress: false, // NotExpress	Bool	是否递送
        Name: "", // Name	string	SN号	是
        ContractName: "", // ContractName	string	合同号	是
        SystemName: "", // SystemName	string	系统
        Fusion: "", // Fusion	string	Fusion版本
        MACAddr: "", // MACAddr	string	MAC地址
        IPAddr: "", // IPAddr	string	IP地址
        DNSAddr: "", // DNSAddr	string	网关掩码DNS
        Licensee: "", // Licensee	string	LicenseeName
        RegeditInfo: "", // RegeditInfo	string	Wavelink注册信息
        State: false, // State	Bool	是否巡检
      },
      snListPop: false,
      // sn列表
      snListId: {
        compid: null,
        sn: "",
      },
      snListData: [
        {
          columnType: "check",
        },
        {
          headerLabel: "SN号",
          dataIndex: "Name",
        },
        {
          headerLabel: "客户",
          dataIndex: "CompanyName",
        },
        {
          headerLabel: "型号",
          dataIndex: "ModelNoName",
        },
        {
          headerLabel: "巡检结果",
          dataIndex: "CheckResultName",
        },
        {
          headerLabel: "备注",
          dataIndex: "Remarks",
        },
        {
          headerLabel: "是否合同内",
          dataIndex: "IsContract",
          dataRender: (v) => {
            if (v == true) {
              return "是";
            } else if (v == false) {
              return "否";
            } else {
              return v;
            }
          },
        },
      ],
      // ---------------------------------------
      // 备机 产品 数据
      // 品牌数据
      BrandData: null,
      //产品类别
      ProductData: null,
      //产品型号
      modelData: null,
      //附件
      AttachData: null,
      popSaveData: {
          BrandId: null,      // BrandId	int	品牌Id  1
          ProductId: null,    // ProductId	int	产品Id 1 
          ModelNo_Id: null,    // ModelNo_Id	int	型号Id 1
          sn: "",   // sn	string	SN 1
          Attach: [], // Attach	Int	附件Id
          Company_Id: null,
          PreMachDesc: "",        // PreMachDesc	string	备注 1
      },
      popTemplate:[
        {
          headerLabel: "客户",
          dataIndex: "CompName",
        },
        {
          headerLabel: "联系人",
          dataIndex: "LinkMan",
        },{
          headerLabel: "联系电话",
          dataIndex: "TelNo",
        },{
          headerLabel: "联系手机",
          dataIndex: "Phone",
        },
        {
          headerLabel: "寄送日期",
          dataIndex: "TranDate",
        },
        {
          headerLabel: "寄送单号",
          dataIndex: "TransferNo",
        },
        {
          headerLabel: "返回地",
          dataIndex: "ReCompName",
        },
        {
          headerLabel: "归还日期",
          dataIndex: "ReturnDate",
        },
        {
          headerLabel: "归还单号",
          dataIndex: "ReTransferNo",
        }
      ],
      popListData: [],
      selectLinkMan: [],
      selectChildData: null,
      TransCompData: [],
      // 列表详情
      listDetails: [],
      // 结单、寄回
      status: 1,
      dialogFormDataCondition: {
        IsRuturn: null,
        SerialNoName: null
      }
    };
  },
  created() {
    this.selectOuguName();
    this.companyAdd();
    this.getCompan()
    this.selectTransCompName()
    this.selectTransMethodName()

    this.selectOuguNameGuiHuan()
    
  },
  computed: {
    // editListDialog: function () {
    // 	return console.log("执行了computed")
    // }
    // this.CustomerList.compid = row.CusCopmany_Id
  },
  watch: {
    // 'CustomerList.compid': function (newV, lodV) {
    // 	console.log(newV, lodV)
    // },
    // editListDialog(newV, lodV){
    // 	console.log(newV, lodV)
    // }
  },
  updated: function () {
    var dialog = this.CustomerList.Id;
    if (dialog != null) {
      this.$refs.tabelSNlist.reloadData();
    }

    var snListId = this.snListId.Id;
    if (snListId != null) {
      this.$refs.tabelSN.reloadData();
    }
  },
  methods: {
    getReqData(reqdata){
      console.log("getReqData-",reqdata)
    },
    async searchBTN(v){
      console.log("searchBTN-",v)
      console.log("searchBTN2-",this.dialogFormDataCondition)
      // this.getReqData()
      const params = {
          ...v,
          sn: this.dialogFormDataCondition.SerialNoName,
          page: 1,
          limit: 20,
        };
        let source = await tableApi.PreMachineListDetailSearch(params);
        console.log("searchBTN-",source)
        this.popListData = source.data.list
    },
    async selectOuguBrand() {
      let source = await tableApi.BrandSelect();
      if (source.code == 0) {
        let data = source.data.list.map(({ id, Name }) => {
          return {
            label: Name,
            value: id,
          };
        });
        let total = 0;
        return {
          total,
          data,
        };
      } else {
        errMsg(this, source.message);
      }
    },
    // 二级数据
    async selectOuguNameProductTwo(Bid) {
      let source;
      if (this.selectChildData == null) {
        source = await tableApi.ProductSelect();
      } else {
        source = await tableApi.ProductSelect({ Bid });
      }
      // this.selectChildData = source.data.list;
      if (source.code == 0) {
        let data = source.data.list.map(({ id, Name }) => {
          return {
            label: Name,
            value: id,
          };
        });
        let total = 0;
        return {
          total,
          data,
        };
      } else {
        errMsg(this, source.message);
      }
    },
    // 三级数据
    async selectOuguNameModelSelect(ProductCategoryId) {
      let source;
      if (this.selectChildData == null) {
        source = await tableApi.modelSelect();
      } else {
        source = await tableApi.modelSelect({ ProductCategoryId });
      }
      
      // this.selectChildMoid = source.data.list;
      if (source.code == 0) {
        let data = source.data.list.map(({ id, Name }) => {
          return {
            label: Name,
            value: id,
          };
        });
        let total = 0;
        return {
          total,
          data,
        };
      } else {
        errMsg(this, source.message);
      }
    },
    LinkManBtn(id){
      let link  = this.selectChildData.filter( f => f.id == id)
        this.popDataSubmit.TelNo = link[0].TelNo
        this.popDataSubmit.Phone = link[0].Phone
        this.popDataSubmit.Email = link[0].Email
        this.popDataSubmit.Fax = link[0].FaxNo
        this.popDataSubmit.Post = link[0].PostNo
        this.popDataSubmit.Address = link[0].Address
    },
    // 联系人数据
    async selectOuguNameProduct(id) {
      let source;
        source = await tableApi.linkMan({ Company_Id: id });
        this.selectChildData = source.data.list.map( (  {LinkMan, id, ...links}= item ) => {
        return {Name: LinkMan, id: LinkMan, ...links}
      })

      if (source.code == 0) {
        let data = source.data.list.map((i) => {
          return {
            Name: i.LinkMan,
            id: i.LinkMan,
          };
        });
        let total = 0;
        return {
          total,
          data,
        };
      } else {
        errMsg(this, source.message);
      }
    },
    async selectTransCompName() {
      let source = await tableApi.TransComp();
      if (source.code == 0) {
        let data = source.data.list.map(({ id, Name }) => {
          return {
            label: Name,
            value: id,
          };
        });
        let total = 0;
        return {
          total,
          data,
        };
      } else {
        errMsg(this, source.message);
      }
    },
    async selectTransMethodName() {
      let source = await tableApi.TransMethod();
      if (source.code == 0) {
        let data = source.data.list.map(({ Id, Name }) => {
          return {
            label: Name,
            value: Id,
          };
        });
        let total = 0;
        return {
          total,
          data,
        };
      } else {
        errMsg(this, source.message);
      }
    },
    // 客户 change id
    hendCompId(id){
      console.log("@hendCompId", id)
      if ( id ) {
        this.selectOuguNameProduct(id)
      }
    },
    addProductBtn(){
      // let list = 
      // vm.$set(this.popListData, 0, obj)
      this.popSaveData = {
          BrandId: null,      // BrandId	int	品牌Id  1
          ProductId: null,    // ProductId	int	产品Id 1 
          ModelNo_Id: null,    // ModelNo_Id	int	型号Id 1
          sn: "",   // sn	string	SN 1
          Attach: [], // Attach	Int	附件Id
          Company_Id: null,
          PreMachDesc: "",        // PreMachDesc	string	备注 1
      }
      console.log('添加产品--')
      this.addProductShow = true
      let id = 0;
      this.$nextTick(() => {
          this.$refs.getMenuList2.showPopDialog(
              { id },
              "备机设备编辑信息",
              "slot"
          );
      });
    },
    listSubmitBtn(){
      // SN,
      // PreMachDesc,
      // IsRuturn
      let submitObj = this.dialogFormDataCondition
      console.log('submitObj--', submitObj)
      // tableApi.PreMachineApplyCommit(submitObj).then((res) => {
      //   console.log('保存成功-', this.popSaveData)
      // })
      const params = {
          sn: submitObj.SerialNoName,
          desc: submitObj.PreMachDesc,
          IsRuturn: submitObj.IsRuturn
        };
        tableApi.PreMachineEditeCommit(params).then((res) => {
          if (res.code == 0) {
            this.loadShow = false
            this.dialogFormDataCondition = { IsRuturn: null }
            successMsg("保存成功");
          } else {
            errMsg(res.message)
          }

      });

    },
    saveBTN(){
      console.log('添加1-', this.popSaveData)
      const saveDataBtn = this.popSaveData
      // if (condition) {
        
      // }
      let Attach='',AttachName = ''
      if ( saveDataBtn.Attach.length > 0 ) {
          Attach = saveDataBtn.Attach.join(',')
          // AttachName = a.filter(x => sb.has(x))
          AttachName =  this.AttachData.filter( item => saveDataBtn.Attach.indexOf(item.id)>-1).map( i => {
            return i.Name
          }).join(',')
        }
      const params = {
        list: [{
          Attach,
          AttachName,
          "Company_Id": saveDataBtn.Company_Id,
          "SerialNoName": saveDataBtn.sn,
          "PreMachDesc": saveDataBtn.PreMachDesc,
          "ModelNo_Id": saveDataBtn.ModelNo_Id
        }]
      };
     
      tableApi.PreMachineMangeFinishById(params).then((res) => {
        if (res.code == 0) {
          successMsg(res.message)
        }
        this.addProductShow = false
        this.reloadData();
      });

      // BrandData     品牌名称
      // ProductData   产品类别
      // modelData     产品型号
      // AttachData    附件
     
      // console.log('this.popListData--',this.popListData)
      //   tableApi.SerialNoApplyCheck({ sn: saveDataBtn.sn }).then((res) => {
      //     console.log(res, "sn测试");
      //     if (res.code != 0) {
      //       errMsg(res.message);
      //       return;
      //     }
      //     console.log('@', this.popSaveData)
          // data.sendBackDialogAddFJ = false;
          // BrandId: null,      // BrandId	int	品牌Id  1
          // ProductId: null,    // ProductId	int	产品Id 1 
          // ModelNo_Id: null,    // ModelNo_Id	int	型号Id 1
          // sn: "",   // sn	string	SN 1
          // Attach: [], // Attach	Int	附件Id
          // PreMachDesc: "",        // PreMachDesc	string	备注 1
          // this.popListData.push(JSON.parse(JSON.stringify(obj)))
          // this.addProductShow = false

          // 清除保存数据
        //   this.popSaveData = {
        //       BrandId: null,      // BrandId	int	品牌Id  1
        //       ProductId: null,    // ProductId	int	产品Id 1 
        //       ModelNo_Id: null,   // ModelNo_Id	int	型号Id 1
        //       sn: "",             // sn	string	SN 1
        //       Attach: [],         // Attach	Int	附件Id
        //       PreMachDesc: "",    // PreMachDesc	string	备注 1
        //   }
        //   this.AttachData = null
        // });
    },
    //  备机----------------------------------------------
    //   归还
    async selectOuguNameGuiHuan() {
        let data = [{label:'是',value: 1},{label:'否',value: 0}]
        let total = 0;
        return {
          total,
          data,
        };
    },
    //   客户数据
    async selectOuguName() {
      let source = await tableApi.CompanyInfo();
      this.CompanyIdData = source.data.list;
      if (source.code == 0) {
        let data = source.data.list.map(({ Company_Id, CompName }) => {
          return {
            label: CompName,
            value: Company_Id,
          };
        });
        let total = 0;
        return {
          total,
          data,
        };
      } else {
        errMsg(this, source.message);
      }
    },
    // shooin公司数据
    async selectOuguNameShooin() {
      let source = await tableApi.CompanyInfoShooin();
      this.CompanyIdData = source.data.list;
      if (source.code == 0) {
        let data = source.data.list.map(({ Company_Id, CompName }) => {
          return {
            label: CompName,
            value: Company_Id,
          };
        });

        let total = 0;
        return {
          total,
          data,
        };
      } else {
        errMsg(this, source.message);
      }
    },
    // 工程师数据 
    async RepairPlantUser() {
      let source = await RepairPlantUser();
      this.CompanyIdData = source.data.list;
      if (source.code == 0) {
        let data = source.data.list.map(({ Id, Name }) => {
          return {
            label: Name,
            value: Id,
          };
        });
        let total = 0;
        return {
          total,
          data,
        };
      } else {
        errMsg(this, source.message);
      }
    },
    // 重新加载表格数据
    reloadData() {
      this.$refs.tabel.reloadData();
    },
    companyAdd() {
      CompanyInfoes().then((data) => {
          if (data.code == 0) {
              this.companyData = data.data.list;
              this.companyData.forEach((i) => {
                  if (i.pid) {
                      this.companyID = i.Company_Id
                      this.companyValue()
                  }
              })

              // pid: 1
          } else {
              errMsg(data.message);
          }
      });

      tableApi.BrandSelect().then((data) => {
          if (data.code == 0) {
              this.BrandData = data.data.list;
          } else {
              errMsg(data.message);
          }
      });
    },
    //产品类别
    addProductSelect() {
        let Bid = this.popSaveData.BrandId;
        tableApi.ProductSelect({ Bid }).then((data) => {
            if (data.code == 0) {
                this.ProductData = data.data.list;
            } else {
                errMsg(data.message);
            }
        });
    },
    //产品型号
    addModelSelect() {
        let ProductCategoryId = this.popSaveData.ProductId;
        tableApi.modelSelect({ ProductCategoryId }).then((data) => {
            if (data.code == 0) {
                this.modelData = data.data.list;
            } else {
                errMsg(data.message);
            }
        });
        this.addAttachSelect();
        // this.addModelIllSelect();
    },
    //附件
    addAttachSelect() {
        this.AttachData = null
        let ProductCategoryId = this.popSaveData.ProductId;
        tableApi.AttachSelect(ProductCategoryId).then((data) => {
            if (data.code == 0) {
                this.AttachData = data.data.list;
            } else {
                errMsg(data.message);
            }
        });

    },
    companyValue() {
        this.LinkManID = null;
        this.LinkManData = null;
        this.formInline = {};

        let Company_Id = this.companyID;
        if (Company_Id === null) {
            console.log("选择公司")
        } else {
          tableApi.linkMan({ Company_Id }).then((data) => {
                if (data.code == 0) {
                    this.LinkManData = data.data.list;
                } else {
                    errMsg(data.message);
                }
            });
        }
    },
    // 公司联系人
    CompanyContract(e) {
      CompanyContractSearch({
        companyId: e,
      }).then((data) => {
        if (data.code == 0) {
          this.CompanyContacts = data.data.list;
        } else {
          errMsg(data.message);
        }
      });
    },
    // 服务类型
    CompanyServerType() {
      ServerTypeSearch().then((data) => {
        if (data.code == 0) {
          this.ServerType = data.data.list;
        } else {
          errMsg(data.message);
        }
      });
    },
    // 工程师查询
    engineerName() {
      RepairPlantUser().then((data) => {
        if (data.code == 0) {
          this.engineerData = data.data.list;
        } else {
          errMsg(data.message);
        }
      });
    },
    getContracsArr(e) {
      if (this.ruleForm.PlantUser == "") {
        this.ruleForm.PlantUser += `${e.Id}`;
      } else {
        this.ruleForm.PlantUser += `,${e.Id}`;
      }
      this.ruleForm.PlantUserName.push(e.Name);
    },
    CompanyContracsData(e) {
      this.ruleForm = { ...this.ruleForm, ...e };
    },
    // 删除1
    delSingleUser(row) {
      // let Id = row.Id;
      ElMessageBox.confirm("确定删除吗？", '提示', {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: 'warning'
        }).then(() => {
          tableApi.DelPreMachineListById({ Id: row.Id }).then(res => { successMsg("删除成功") })
          this.reloadData();
        }).catch(() => { })
    },
    
    getCompan() {
        tableApi.MyUserInfoeShooin().then((res) => {
          this.sendBackForm.options = res.data.list.map((i) => ({
            label: i.CompName,
            value: i.Company_Id,
          }));
        });
    },
    //弹层事件
    popConfirmButtonClick({ slotData }) {
      console.log('@1',slotData);
    },
    customerRowDblClick(row) {
      if (row) {
        this.dialogFormDataCondition = row
      }
      let conditionParams = this.popDataSubmit
      const params = {
          ...conditionParams,
          sn: this.dialogFormDataCondition.SerialNoName,
          page: 1,
          limit: 20,
        };
      tableApi.PreMachineListDetailSearch(params).then((res) => 
      {
          console.log('@3',res.data.list);
          this.popListData = res.data.list
          this.loadShow = true
          let id = 0;
          this.$nextTick(() => {
              this.$refs.getMenuList.showPopDialog(
                  { id },
                  "备机详细",
                  "slot"
              );
          });
      });
        // this.editListDialog = true;
      
    },
    addList() {
      this.addDialog = true;
      this.CompanyServerType();
    },
    // 客户列表编辑
    editTabelSN(row) {
      if (!row.Id) {
        return;
      }
      console.log("edit---", row);
      this.snListPop = true;
      this.snListId.compid = row.Id;
    },

    getBirthTime(val, name) {
      let year = val
        .getFullYear()
        .toString()
        .PadLeft(4, "0");
      let month = (val.getMonth() + 1).toString().PadLeft(2, "0");
      let date = val
        .getDate()
        .toString()
        .PadLeft(2, "0");
      let hour = val
        .getHours()
        .toString()
        .PadLeft(2, "0");
      let minute = val
        .getMinutes()
        .toString()
        .PadLeft(2, "0");
      let sec = val
        .getSeconds()
        .toString()
        .PadLeft(2, "0");
      let dataTime = `${year}-${month}-${date} ${hour}:${minute}:${sec}`;
      let dataDate = `${year}-${month}-${date}`;

      const newDate =
        val.getFullYear() + "-" + (val.getMonth() + 1) + "-" + val.getDate();

      if (name === "AddDate") {
        this.ruleForm[name] = dataTime;
        return;
      }

      if (name === "edt") {
        this.ruleFormFinish.edt = dataTime;
        return;
      }

      if (name === "ruleForm") {
        this.editForm[name] = dataTime;
        return;
      }

      this.ruleForm[name] = newDate;
    },
    // 添加任务
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          //巡检完成
          if (formName === "ruleFormFinish") {
            this.$refs.upload.submit();
            return;
          }
          //巡检保存
          if (formName === "editForm") {
            console.log("editForm:", this.editForm);
            this.editForm.IsPublic = true;
            let addParam = JSON.stringify(this.editForm);
            ServerPlantTasksEditSave({ data: addParam }).then((data) => {
              if (data.code == 0) {
                this.editListDialog = false;
                this.reloadData();
              } else {
                errMsg(data.message);
              }
            });
            return;
          }

          if (formName === "ruleForm") {
            let addParam = JSON.stringify(this.ruleForm);
            ServerPlantAdd({ data: addParam }).then((data) => {
              if (data.code == 0) {
                this.addDialog = false;
                this.reloadData();
              } else {
                errMsg(data.message);
              }
            });
            return;
          }
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    // 查图片
    handOpenImg(row) {
      this.openImg =
        row.Terminal || "http://192.168.1.237:8088/img/482.137a0e6e.jpg";
      this.centerDialogVisible = true;
    },
    handOpenFile(row) {
      this.openImg =
        row.Terminal || "http://192.168.1.237:8088/img/482.137a0e6e.jpg";
      this.centerDialogVisible = true;
    },
    resetForm(formName) {
      if (formName === "ruleFormFinish") {
        this.$refs[formName].resetFields();
        return;
      }
      this.$refs[formName].resetFields();
    },
    handleBefore(file) {
      console.log("handleBefore", file);
    },
    // addListBtn
    addListBtn() {
      console.log("添加1");
      this.dialogFormDataCondition = { IsRuturn: null }
      this.loadShow = true
      // this.addProductShow = true
      let id = 0;
      this.$nextTick(() => {
          this.$refs.getMenuList.showPopDialog(
              { id },
              "备机借用详细",
              "slot"
          );
      });
      // tableApi.FuDaoContractList(this.conditionData).then((data) => {
      //   downloadExcel(data, "服务记录");
      // });
    },
  },
};
</script>

<style lang="scss" scoped="scoped">
@import "~@/assets/styles/_handle.scss";

#suerSwitch .el-switch__core {
  width: 26px;
}

.el-tabs--card>.el-tabs__header .el-tabs__item.is-active {
  background: red;
}

.user-management-container {
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  overflow: hidden;
  align-items: center;
  align-content: center;
  @include background_color("user-management-bg-color");

  .del {
    margin-left: 10px;
  }

  .condition-container-input {
    margin: 5px 10px;
    width: 300px;
  }

  .opration {
    height: 100%;
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    align-content: center;

    .item {
      &:nth-child(n + 1) {
        margin-left: 10px;
      }
    }
  }

  .menuPowerBOX {
    .el-button--default {
      width: 90px;
      height: 30px;
      color: #ffffff;
      background: rgb(100, 134, 232);
      border-radius: 4px;
    }

    .item {
      height: 30px;
      color: #ffffff !important;
      padding: 10px 15px !important;
      background: rgb(100, 134, 232) !important;
    }
  }


  .oprationTree {
    background-color: #ecf5ff;
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    padding: 25px 20px 15px 20px;

    .detailed-box {
      width: 100%;
      height: 100%;
      position: relative;
      border: 1px solid #99bce8;
      background-color: #f4f7f6;
      border-radius: 10px;

      .detailed-title {
        font-family: Microsoft YaHei;
        font-weight: normal;
        padding: 10px;
      }

      .text-field-container {
        background: #f4f7f6 !important;
        margin: 10px 20px;
        width: 320px;
      }

      .pop-dialogClose {
        position: absolute;
        top: 20px;
        right: 15px;

        .el-icon-close:before {
          font-size: 28px;
        }

        .el-icon-close:hover {
          color: #f92323;
        }
      }
    }
  }

  .pop-dialog-conver {
    // display: block !important;
    width: 100% !important;
    height: 100% !important;
  }

  .control-button-container {
    color: #409eff;
  }

  .el-radio {
    display: flex;
    width: 300px;
    justify-content: space-evenly;
    flex-direction: row-reverse;
    padding: 20px 20px;
  }

  .el-radio-group {
    width: 100%;
    display: inherit;
    font-family: hanSan !important;
    font-size: 20px;
  }

  .el-checkbox {
    padding-right: 16px;
  }

  .el-select {
    width: 100%;
  }

  .el-upload--picture-card {
    height: 20px !important;
    line-height: 20px !important;
  }

  .tabel-panel-container {
    width: 100%;
    // @include border_all("tabel-panel-border");
    border-radius: 4px;

    &:deep(.headerClass) {
      height: 100%;
      width: 100%;
      @include background_color("tabel-header-bg-color");
      height: 40px;
      @include border_right("tabel-header-border-right");
      box-sizing: border-box;
      @include font_color("tabel-row-font-color");
    }

    &:deep(.cellClass) {
      font-size: 16px;
      @include font_family("font_family");
      @include font_color("tabel-row-font-color");
      height: 40px;
      @include border_bottom("tabel-row-border-bottom");
      @include border_right("tabel-row-border-right");
    }
  }

  ::v-deep .snBox .el-dialog__body {
    padding-top: 0;
  }

  // 备机设备编辑信息
  #loadBOX {
      width: 100%;

      .saveBox {
          width: 800px !important;
      }

      .saveBox>div {
          padding: 10px;
          margin: 10px;

          .el-checkbox {
              margin-right: 15px;
          }

          .colorRed {
              color: red;
          }
      }
  }

}

.el-form-item {
  margin-bottom: 15px;
}

#SNDialog {
  width: 100%;
  height: 100%;
  margin: 0;
}

::v-deep .el-form-item__content {
  display: flex;
}

::v-deep .el-table .warning-row {
  background-color: #6486e8;
  color: #505050;
}

::v-deep .del-button .del-button-icon {
  margin-right: 0;
}

:deep(.el-table--scrollable-x .el-table__body-wrapper) {
  overflow-x: auto !important;
}

.style-aaa {
  cursor: pointer;
  color: rgb(100, 134, 232);
  // style="{cursor:'pointer',color:'rgb(100,134,232)'}"
}
#dialogBox{
  ::v-deep .title-panel-container{
    height: 1.3125rem !important;
      .title-name{

        flex-wrap: wrap;
        .condition-container-input{
          // width: 1.45rem;
          // margin-right: 0;
          // margin-left: 0;
          .label-container{
            padding-right: 0;
          }
        }
      }
  }
}



</style>
